export const ScrollToTop = (behavior: ScrollOptions["behavior"] = "smooth") => {
  const scrollOptions: ScrollToOptions = {
    left: 0,
    top: 0,
    behavior: behavior,
  };
  window.scrollTo(scrollOptions);
};
